var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14829_10191)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3721 5.09131L29.1469 8.67278L33.1133 9.24879L30.2416 12.0366L30.9194 15.9741L27.3693 14.1178L23.8192 15.9741L24.4971 12.0366L21.6282 9.24879L25.5974 8.67447L27.3721 5.09131Z",
    fill: "#136FF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14829_10191",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 30,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9272 3.51123H4.92725V32.5112H33.9272V3.51123Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14829_10191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.446 21.9965C19.7658 20.9694 16.6919 17.8745 15.6842 15.1964C14.9719 13.4076 14.6735 11.482 14.8109 9.56262C14.9484 7.64322 15.5184 5.77933 16.4784 4.10937C16.5183 4.04094 16.5369 3.96223 16.5317 3.88326C16.5266 3.80429 16.498 3.72863 16.4495 3.66591C16.4011 3.60318 16.335 3.55623 16.2597 3.53103C16.1843 3.50582 16.1032 3.5035 16.0265 3.52436C13.5204 4.16712 11.2275 5.45361 9.37699 7.25528C7.5265 9.05696 6.18323 11.3107 5.4814 13.7913C4.77957 16.2719 4.74376 18.8925 5.37755 21.3913C6.01134 23.89 7.29254 26.1793 9.09311 28.0304C10.8937 29.8816 13.1506 31.2297 15.6382 31.9402C18.1259 32.6506 20.7572 32.6984 23.2693 32.0789C25.7813 31.4593 28.0861 30.1941 29.9533 28.4096C31.8205 26.6251 33.1848 24.3839 33.9097 21.9099C33.9322 21.8343 33.9318 21.7538 33.9084 21.6786C33.885 21.6033 33.8398 21.5366 33.7784 21.4869C33.717 21.4372 33.6422 21.4067 33.5634 21.3993C33.4847 21.3919 33.4055 21.4079 33.3358 21.4452C31.6716 22.3248 29.834 22.83 27.9524 22.9252C26.0708 23.0204 24.1912 22.7034 22.446 21.9965Z",
    fill: "#71B2FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14829_10191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(4.92725 3.51123)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExtend);
export default __webpack_public_path__ + "static/media/icon_extend.0b008dd545747c4829ffae2d295a817a.svg";
export { ForwardRef as ReactComponent };